var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 200,
    viewBox: "0 0 211 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7759_28045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.385 104.2C201.385 130.719 190.56 154.623 173.203 171.803C156.22 188.798 132.704 199.069 106.762 199.069C81.0069 199.069 57.4911 188.611 40.3208 171.803C22.9639 154.623 12.1392 130.719 12.1392 104.2C12.1392 51.724 54.5049 9.33203 106.762 9.33203C159.019 9.33203 201.385 51.9107 201.385 104.2Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.175 42.0165C197.4 42.0165 200.827 38.5884 200.827 34.3598C200.827 30.1311 197.4 26.7031 193.175 26.7031C188.947 26.7031 185.523 30.1311 185.523 34.3598C185.523 38.5884 188.947 42.0165 193.175 42.0165Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.373 12.1337C207.258 12.1337 209.598 9.79263 209.598 6.90475C209.598 4.01687 207.258 1.67578 204.373 1.67578C201.485 1.67578 199.147 4.01687 199.147 6.90475C199.147 9.79263 201.485 12.1337 204.373 12.1337Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1254 41.8251C18.0115 41.8251 20.3511 39.4839 20.3511 36.5962C20.3511 33.7083 18.0115 31.3672 15.1254 31.3672C12.2393 31.3672 9.89966 33.7083 9.89966 36.5962C9.89966 39.4839 12.2393 41.8251 15.1254 41.8251Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.205 54.5273V171.806C156.22 188.8 132.705 199.071 106.763 199.071C81.0071 199.071 57.4913 188.613 40.321 171.806V54.5273H173.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.11 114.385L83.1125 88.3711L74.2705 97.2183L100.268 123.232L109.11 114.385Z",
    fill: "#979FAF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.434 75.4414L91.6353 114.264L100.477 123.111L139.276 84.2888L130.434 75.4414Z",
    fill: "#979FAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73 139.125H72.7952V147.715H140.73V139.125Z",
    fill: "#D5DAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73 157.988H72.7952V166.579H140.73V157.988Z",
    fill: "#D5DAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.12 177.031H89.4058V185.622H124.12V177.031Z",
    fill: "#D5DAE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7759_28045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 199.821,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoUpdated);
export default __webpack_public_path__ + "static/media/InfoUpdated.df97e95fffbea14948490e2c2495188c.svg";
export { ForwardRef as ReactComponent };